import React,{useRef,useEffect} from 'react';  
import ReactDom from 'react-dom';
import {
    Button,
    Container,
    Divider,
    Grid,
    Header,
    Icon,
    Image,
    List,
    Menu,
    Responsive,
    Segment,
    Sidebar,
    Visibility,
  } from 'semantic-ui-react'
  import LazyLoad from 'react-lazy-load';
  import useWindowDimensions from '.././UseWindowDimensions'
import { tsPropertySignature } from '@babel/types';


  function Cell(props)
  { 
      var imageWidth = 600; //add 30 to account for margin
     var imageHeight =  props.imageHeight || 400 ; 
      return <Grid.Column width={props.cellWidth} style={{paddingBottom:'1em', paddingTop:'1em'}}>  
      <Container text>
      <Header inverted as='h3'  style={{fontSize:'1em'}}>
        {props.headerText}
      </Header> 
      <p style={{fontSize:'1em'}}>
        {props.body}
      </p>  
      </Container>
      <LazyLoad  height={Math.min((props.width/imageWidth * imageHeight),imageHeight )}> 
        <img src={"/gifs/" + props.gif} style={{width:Math.min(imageWidth,props.width-30), height:'auto'}}/>
      </LazyLoad>   
    </Grid.Column>
  }
  function GifGrid(props){
      var columnWidth = props.width < 1200 ? 16 : 8; 
      return   <Grid  columns='equal' stackable>  
      <Grid.Row textAlign='center'>
          <LazyLoad  height={60}>
              <div></div>
            </LazyLoad> 
        </Grid.Row>
        <Container text> 
            <Header inverted as='h3' color='blue'  style={{fontSize:'2em'}}>
            {props.headerText } 
          </Header> 
          <Header inverted as='h3'  style={{fontSize:'1em'}}>
            {props.headerSubText } 
          </Header> 
          </Container> 
          
      <Grid.Row textAlign='center'> 
         {props.gifData.map(gifDetail=> (
             <Cell
                key = {gifDetail.gif}
                cellWidth = {columnWidth}
                headerText = {gifDetail.headerText}
                gif = {gifDetail.gif}
                width = {props.width}
                height = {props.height}
             > </Cell>)
          )} 
        </Grid.Row> 
        
      </Grid> 
  }
  
export default GifGrid;